import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ReactComponent as EmailIcon } from "../../../../../assets/images/People/Customers/email.svg";
import { ReactComponent as StatusIcon } from "../../../../../assets/images/People/Customers/status.svg";
import { ReactComponent as RoleIcon } from "../../../../../assets/images/People/Groups/team-agent.svg";
import { ReactComponent as LastActivityIcon } from "../../../../../assets/images/People/Customers/last-seen.svg";
import { ReactComponent as ConversationsIcon } from "../../../../../assets/images/People/Customers/conversations.svg";
import CustomerDetailInfoField from "../../Customers/CustomerDetail/CustomerDetailInfoField";
import AgentRolePill from "../AgentRolePill";
import AgentPresenceChip from "./AgentPresenceChip";
import { sectionCardSx, sectionTitleSx } from "./agentDetailSectionStyles";

export default function AgentDetailInfoSection({ agent }) {
  const leftFields = [
    { icon: EmailIcon, label: "Email", value: agent.email },
    {
      icon: RoleIcon,
      label: "Role",
      valueNode: <AgentRolePill role={agent.role} />,
    },
    {
      icon: ConversationsIcon,
      label: "Conversations",
      value: String(agent.chats ?? 0),
    },
  ];

  const rightFields = [
    {
      icon: StatusIcon,
      label: "Status",
      valueNode: (
        <AgentPresenceChip presence={agent.presence} label={agent.presenceLabel} />
      ),
    },
    { icon: LastActivityIcon, label: "Last Activity", value: agent.lastActivity },
  ];

  return (
    <Box sx={{ mb: 3 }}>
      <Typography sx={sectionTitleSx}>Information</Typography>
      <Box sx={{ ...sectionCardSx,  }}>
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
            gap: 3,
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            {leftFields.map((field) => (
              <CustomerDetailInfoField key={field.label} {...field} />
            ))}
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 3 }}>
            {rightFields.map((field) => (
              <CustomerDetailInfoField key={field.label} {...field} />
            ))}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
